import { render, staticRenderFns } from "./AppMoreMenu.vue?vue&type=template&id=a0ae5f16&scoped=true&"
import script from "./AppMoreMenu.vue?vue&type=script&lang=js&"
export * from "./AppMoreMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppMoreMenu.vue?vue&type=style&index=0&id=a0ae5f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae5f16",
  null
  
)

export default component.exports